import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import PreviewQRCard from "@/components/share/PreviewQRCard";
import { Loader2, QrCode } from "lucide-react";
import { toast } from "sonner";

export default function ShopPreviewQR() {
  const [qr, setQr] = useState(undefined);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/my/rider-preview/qr-code"); setQr(data); setErr(null); }
    catch (e) { setErr(apiError(e.response?.data?.detail)); setQr(null); }
  };
  useEffect(() => { load(); }, []);

  const regenerate = async () => {
    setBusy(true);
    try { const { data } = await api.post("/my/rider-preview/qr-code/regenerate"); setQr(data); toast.success("QR code refreshed"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (qr === undefined) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-4" data-testid="shop-preview-qr">
      <div className="flex items-center gap-2">
        <QrCode className="w-5 h-5 text-primary" />
        <div>
          <h2 className="font-heading text-lg font-bold">Rider Preview QR Code</h2>
          <p className="text-sm text-muted-foreground">Print it for your shop, share it with staff, or add it to onboarding materials. Riders scan it to preview your bike path.</p>
        </div>
      </div>
      {err ? (
        <div className="rounded-2xl border border-dashed border-border bg-card p-12 text-center text-muted-foreground" data-testid="shop-qr-error">{err}</div>
      ) : (
        <PreviewQRCard qr={qr} busy={busy} onRegenerate={regenerate} />
      )}
    </div>
  );
}
